<template>
  <v-container>
    <v-app-bar app color="secondary" dark dense>
      <v-toolbar-title>
        {{ $t("contact.title") }}
      </v-toolbar-title>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <Markdown :value="$t('contact.content')"></Markdown>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {};
</script>
